import { z } from 'zod';

export const PreferencesMfaPhoneActivateFormSchema = z.object({
  registeredForMfa: z.boolean(),
});
